import { useNavigate } from 'react-router-dom';
import '../App.css'
import './PublicNavbar.css';

function PublicNavbar({ onSignInClick }) {
  const navigate = useNavigate();

  return (
    <nav className="public-navbar">
      <div className="public-navbar-container">
        <div className="public-navbar-left">
          <div className="public-brand" onClick={() => navigate('/login')}>
            <img
              src="/PMLogo.png"
              alt="Playmaker Media Kit"
              className="public-logo-icon"
            />
            <img
              src="/PMlogowords.png"
              alt="Playmaker Media Kit"
              className="public-logo-words"
            />
          </div>
        </div>
        <div className="public-navbar-right">
          <button className="btn btn-primary" onClick={onSignInClick}>
            Sign In
          </button>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/register')}
          >
            Create Account
          </button>
        </div>
      </div>
    </nav>
  );
}

export default PublicNavbar;
